import { ReactNode, useMemo } from "react";
import { groupTranscriptTurns } from "../transcript-turns";
import { ScribeTranscriptLine } from "../types";
import TranscriptBubble from "./TranscriptBubble";

export interface TranscriptThreadProps {
  lines: ScribeTranscriptLine[];
  /** Rendered after the last turn, e.g. the live "still listening" indicator. */
  trailing?: ReactNode;
}

const TranscriptThread = ({ lines, trailing }: TranscriptThreadProps) => {
  const turns = useMemo(() => groupTranscriptTurns(lines), [lines]);

  return (
    <>
      {turns.map((turn) => (
        <TranscriptBubble key={turn.id} line={turn} />
      ))}
      {trailing}
    </>
  );
};

export default TranscriptThread;
